import React from "react";
import AdminChangelog from "./admin-changelog";
import ChangelogItem from "./changelog/changelog-item";
import ChangelogItemContainer from "./changelog/changelog-item-container";
import ControlButtons from "items/control-buttons/control-buttons";
import { getFormatDate } from "service/format-date";
import { getChangeLogs } from "store/change-log";

class AdminChangelogController extends React.Component{

    constructor(props){
        super(props);
        this.controlButtons = [];
        this.state = {
            selectedItem: null,
            isShowOnly: true,
            selectedLanguage: props.selectedLanguage,
            changeLogs: props.changeLogs,
            count: props.showedItemsCount,
            changelogCount: props.count,
            changelogPage: props.page,
            currentPage: props.currentPage,
            showedItemsCount: props.showedItemsCount
        }
    }

    closeRightMenu = () => {
        this.props.setShowRightMenu(false);
        //this.props.setRightMenuComponent(null);
        this.props.setRemoveRightMenuComponent();
        this.props.setChangeLog(null, null, null)
        this.setState({
            selectedItem: null
        })
    }

    componentDidMount(){
        this.getChangeLogsItems(this.props.selectedLanguage, this.props.currentPage, this.props.showedItemsCount);
    }

    getChangeLogsItems = (selectedLanguage, currentPage, showedItemsCount) => {
        this.props.getChangeLogs(selectedLanguage, currentPage, showedItemsCount);
    }

    deleteChangelog = (id) => {
        this.props.deleteChangelog(this.props.selectedLanguage, id, this.props.currentPage, this.props.showedItemsCount)
    }

    formatDate = (date) =>{
        return getFormatDate(date, "HH:mm DD.MM.YY")//moment(date).format("HH:mm DD.MM.YY");
    }
//notificationType', "incidentTime", "releaseTag", "createdAt", "updatedAt", "createdBy", "content

    setShowOnly = (isShowOnly) => {
        this.setState({
            isShowOnly: isShowOnly
        });
    }

    getChangeLogDta = (changeLogId, language) => {
        this.props.getChangeLog(changeLogId, language);
    }
я
    showRightMenu = (show, markerId, index) => {
        this.closeRightMenu()
        if(show){
            let changelogsItem = {...this.props.changeLogs[index]};
            this.props.setShowRightMenu(true)
            switch(show){
                case 'edit':
                    this.props.setRightMenuComponent(<ChangelogItemContainer type={show} showOnly={false} />, 'changelog u', null, this.props.getValue('EDIT_CHANGELOG_RECORD'), true, this.props.getValue('EDIT_CHANGELOG_RECORD'), this.closeRightMenu);
                    //this.props.setRightMenuComponent(<AddTopicsItemContainer markerId={fmarker.id} page={this.props.topicsPage} setPage={this.setTopicsPageNumber} topic={fmarker} topicsCount={this.props.topicsCount} type={'topics'} callback={this.addMarkerToTopic} getValue={this.props.getValue}/>, 'markerItems', null, this.props.getValue('ATTACH_TOPIC_TO_ACCOUNT'), true, this.props.getValue('ATTACH_TOPIC_TO_ACCOUNT'));
                    break;
                case 'show':
                    this.props.setRightMenuComponent(<ChangelogItemContainer type={show} showOnly={true}/>, 'changelog', null, this.props.getValue('SHOW_CHANGELOG_RECORD'), true, this.props.getValue('SHOW_CHANGELOG_RECORD'), this.closeRightMenu);
                    break;
                case 'create':
                    changelogsItem = {};
                    this.props.setRightMenuComponent(<ChangelogItemContainer type={show} showOnly={false}/>, 'changelog u', null, this.props.getValue('ADD_CHANGELOG_RECORD'), true, this.props.getValue('ADD_CHANGELOG_RECORD'), this.closeRightMenu)
                }          
            
        }
    }

    onTableItemsClick = (type, key, index) => {
        this.setState({
            selectedItem: key
        });
        this.setShowOnly(true);
        switch(type){
            case 'add':
                this.showRightMenu('addItem', key, index)    
                break;
            case 'show':
            case 'edit':
                if(this.props.selectedChangelogItem !== key){
                    this.props.getChangeLog(key, 'ru');
                    this.props.getChangeLog(key, 'en');
                    this.props.getChangeLog(key, 'kk');
                }
                this.showRightMenu(type, key, index);

                type === 'edit' 
                                ? this.setShowOnly(false) 
                                : this.setShowOnly(true);
                break;
            case 'delete':
                this.deleteChangelog(key);
        }
    }

    saveChangelog = (parameters, changeLogId) => {
        this.props.updateChangelog(this.props.selectedLanguage, changeLogId, parameters, this.props.currentPage, this.props.showedItemsCount);
        this.closeRightMenu();
    }

    createChangeLog = (parameters) => {
        this.props.createChangelog(this.props.selectedLanguage, parameters, this.props.currentPage, this.props.showedItemsCount)
    }

    getControlButtonItems = (id, items, index) => {
        return <ControlButtons keyId={id} callback={this.onTableItemsClick} items={items} index={index} />
    }

    setTableValues = (tableValues) => {
        let values = [...tableValues];
        return values.map( (k, i) => {
            let ctrl = [];
            ctrl = this.props.controlButtons 

                this.controlButtons.push(this.getControlButtonItems(k.id, ctrl, i))
                let b = this.getControlButtonItems(k.id, ctrl, i)
            return [i+1, this.props.getValue(k.notificationType), k.releaseTag, this.formatDate(k.incidentTime), this.formatDate(k.createdAt), this.formatDate(k.updatedAt), k.createdBy, k.content, b];
        })
    }

    shouldComponentUpdate(nextProps, nextState){
        if(nextProps.changeLogs !== nextState.changeLogs){
            this.setState({
                //selectedLanguage: nextProps.selectedLanguage,
                changeLogs: nextProps.changeLogs
            })
            return true;
        }
        if(nextProps.selectedLanguage !== nextState.selectedLanguage || nextProps.isChangeLogUpdated || nextProps.currentPage !== nextState.currentPage || nextProps.showedItemsCount !== nextState.showedItemsCount || nextProps.selectedChangelogItem !== nextState.selectedItem){
            nextProps.setIsChangelogUpdated(false);
            this.setState({
                selectedLanguage: nextProps.selectedLanguage,
                currentPage: nextProps.currentPage,
                showedItemsCount: nextProps.showedItemsCount,
                selectedItem: nextProps.selectedChangelogItem
            })
            this.getChangeLogsItems(nextProps.selectedLanguage, nextProps.currentPage, nextProps.showedItemsCount);
            return true;
        }
        else return false;
    }

    render(){
        return (
            <AdminChangelog 
                            {...this.props} 
                            tableHeader={this.props.tableHeader} 
                            data={this.props.changeLogs ? this.setTableValues(this.props.changeLogs) : []} 
                            showRightMenu={this.showRightMenu}
                            />
        )
    }

    componentWillUnmount(){
        this.closeRightMenu();
    }
}

export default AdminChangelogController